import {
  addDays,
  isPast,
  isSameDay,
  isSameWeek,
  isWithinInterval,
} from "date-fns";

import { CalendarView } from "@ds-developer/models";

import { DateData } from "./types";

export const getFutureDate = (date: Date) => {
  if (
    isPast(date) &&
    isSameWeek(date, new Date(Date.now()), {
      weekStartsOn: 1,
    })
  ) {
    return new Date(Date.now());
  }

  return date;
};

export const isDateActive = (
  selectedDate: Date,
  comparisonDate: Date,
  view: CalendarView,
  enforceFutureDate = false,
) => {
  // Week view, activate all dates within selected week
  if (
    view === CalendarView.week &&
    isSameWeek(selectedDate, comparisonDate, {
      weekStartsOn: 1,
    })
  ) {
    return true;
  }

  const selectedFutureDate = enforceFutureDate
    ? getFutureDate(selectedDate)
    : selectedDate;

  // 3 day view, activate selected date plus 2 days in future
  if (
    view === CalendarView.threeDay &&
    isWithinInterval(comparisonDate, {
      start: selectedFutureDate,
      end: addDays(selectedFutureDate, 2),
    })
  ) {
    return true;
  }

  // Day view, activate selected date only
  if (isSameDay(selectedFutureDate, comparisonDate)) {
    return true;
  }

  return false;
};

export const getSelectedDateIndex = (data: DateData) =>
  data.entries.findIndex(entry => entry.selected);

export const getScrollIndex = (data: DateData, offset: number) =>
  getSelectedDateIndex(data) + offset;
